import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readKontrak} from "../ListKontrak/api.js";
import {readEmptyKontrak} from "../ListKontrak/apiEmpty.js";
import {readEmpty} from "./apiEmpty.js";
import Post from "../ListKontrak/Post.jsx";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem, Typography } from '@mui/material';
import DokumenPopUp from './dokumenPopUp'
import { v4 as uuidv4 } from 'uuid';
export default function Domisili(oldPost){

    
    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [kontrakposts, setKontrakPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchKontrakPosts();
        console.log(posts)
    }, [skip,query]);

    async function newKontrak(e){
        history("/create-kontrak",{state:{stuff:"new"}})
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const day = String(date.getDate()).padStart(2, '0');
        const month = monthNames[date.getMonth()]; // get month name
        const year = date.getFullYear().toString();
        return `${day} ${month} ${year}`;
    };
    const formatLokasi = (lokasi) => {
        const lokasiMappings = {
            'Office Tower Eightyeight@Kasablanka Unit 9A': 'Kokas',
            'Ruko Emerald Summarecon Bekasi UC9': 'Bekasi',
            'Ruko Graha Boulevard Summarecon Serpong Blok GBVB 10': 'Serpong',
            'Komplek Perkantoran Duta Merlin Blok F1': 'Duta Merlin'
        };
    
        return lokasiMappings[lokasi] || '';
    };
    

 
    const [fileURL, setFileURL] = useState("");
    const [notes, setNotes] = useState("");
    const [fileURLKontrak, setFileURLKontrak] = useState("");

    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id
    
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
           id 
        }, {
            responseType: "blob"
          }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setFileURLKontrak(fileURLNew)
                    setLoadVisibility(false)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchKontrakPosts = async (event) => {
        setKontrakPosts([])
        if(event.target.value.trim()){
        try{
            const { data, error } = await readKontrak(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                return;
            }
            const yoyo = data.data
            //success
            setKontrakPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmptyKontrak(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    return;
                }
                
                //success
                setKontrakPosts([...kontrakposts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const fetchKontrakPosts = async () => {
        if(query.trim()){
            try{
                const { data, error } = await readKontrak(skip,query,searchThis);
                if(error){
                    
                    console.log(error.message);
                    return;
                }
                console.log(data.data)

                if(data.data?.length === 0){
                    return;
                }

                const yoyo = data.data

                //success
                setKontrakPosts([...kontrakposts, ...yoyo])
            }catch(error){
                console.log(error);
            }
        
    }else{

    try{
        const { data, error } = await readEmptyKontrak(skip,query);
        if(error){
            console.log(error.message);
            return;
        }

        if(data?.length === 0){
            return;
        }
        
        //success
        setKontrakPosts([...kontrakposts, ...data])
    }catch(error){
        console.log(error.message);
    } 
    }
    }

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(kontrakposts?.length);
        }
    }
    const commonStyles = {
        border: 1,
      };
      const previewInquiry = async (post) => {
        const currid = post._id
        const id = post.kontrak_id
        const thisClient= post.data.KlienID
        
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
            id
         }, {
             responseType: "blob"
           }).then(resp => {
                     console.log(resp)
                         const blob = new Blob([resp.data], { type: 'application/pdf' })
                     // saveAs(blob);
                     var fileURLNew = URL.createObjectURL(blob);
                     console.log(fileURLNew)
                     setPreviewVisibility(true)
                     setFileURLKontrak(fileURLNew)
                 })
                 console.log("diatas")
                 setCurrPreview(post)
                 setPreviewVisibility(true)
    }
    const [searchThis, setsearchThis]= useState("KlienNama");
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchKontrakPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        console.log(currPreview)
        console.log(oldPost.oldPost.kontrak_id)
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/iniExtendNya`,{
            id: currPreview._id, oldPost_id: oldPost.oldPost.kontrak_id
        })
    }
    const [dokumenPopUpOpen, setDokumenPopUpOpen] = useState(false)

    const closecekDokumenPopUp = () => {
        setDokumenPopUpOpen(false)
    }
    const cekDokumenPopUp = () => {
        setDokumenPopUpOpen(true)
    }
    const [removedPost,setRemovedPost]=useState(0)

    const salahKlik = (postId) => {
        setRemovedPost(removedPost+1)
        setPosts(posts.filter(post => post._id !== postId));
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/salahklikRemind`,{
            id: currPreview._id
        })
    }
    

    const simpanSekarang = (postId) => {
        setRemovedPost(removedPost+1)
        console.log(currPreview)
        setPosts(posts.filter(post => post._id !== postId));
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/konfirmasiTransaksiBenar`,{
            id: currPreview._id, notes, kontrakid:currPreview.kontrak_id, isMatchingID:currPreview.data.isMatching[0]._id,
        })
    }

    
    const handleNotes = (event) => {
        setNotes(event.target.value)
    }

    const oke = () => {
        // Render Domisili
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderDomisilifromDB`, {
            id: currPreview._id
        }, {
            responseType: "blob"
        }).then(resp => {
            console.log(resp);
            const blob = new Blob([resp.data], { type: 'application/pdf' });
            // saveAs(blob);
            var fileURLNew = URL.createObjectURL(blob);
    
            // Function to upload blob to S3 and get the file URL
            const uploadBlobToS3 = (blob) => {
                const fileType = blob.type;
                return axios.get(`${process.env.REACT_APP_BACKEND_URL}/getTempUploadURL?fileType=${fileType}`)
                    .then(response => {
                        console.log(response)
                        const uploadUrl = response.data.url;
                        const key = response.data.key;
    
                        return fetch(uploadUrl, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': fileType
                            },
                            body: blob
                        }).then(() => ({
                            key,
                            url: uploadUrl.split('?')[0]  // Assuming the URL contains signed parameters after '?'
                        }));
                    })
                    .catch(error => {
                        console.error('Error during file upload:', error);
                    });
            };
    
            // Use the uploadBlobToS3 function
            uploadBlobToS3(blob).then(fileInfo => {
                // fileInfo contains the key and url of the uploaded file
    
                // Send request to approve contract
                console.log("kesiiniiii")
                console.log(fileInfo)
                axios.post(`${process.env.REACT_APP_BACKEND_URL}/approveContract`, {
                    id: currPreview._id,
                    fileUrl: fileInfo.url  // Include the file URL in the request
                })
                .then((response) => {
                    console.log("Approved");
                    handleClosePreview();
                    setCurrPreview();
                    window.location.href = `${window.location.protocol}//${window.location.host}/confirmsignature`;
                });
            });
        });
    };
    
    

    return <Grid>
    <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
    <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURLKontrak} width="100%" height="500" style={{zoom:"150%"}}/>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() => extend()} variant="contained" color="success">
                        Hubungkan
                    </Button>
                    </DialogActions>
                </Dialog>
    <Grid container>
        <Grid item xs={2}>
            <Select  fullWidth value={searchThis} onChange={event => setsearchThis(event.target.value)}><MenuItem value="KlienNama">Klien</MenuItem><MenuItem value="kontrakAmount">Kode Kontrak</MenuItem><MenuItem value="CompanyName">Company</MenuItem></Select>
        </Grid>
        <Grid>
            <TextField value={query} onChange={event => handleSearch(event)}></TextField>
        </Grid>
    </Grid>
<Grid container align = "center" justify = "center" alignItems = "center">
<Paper sx={{}}>
    <TableContainer sx={{ maxHeight: 300 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell style={{ width: 200 }}>
                        Klien
                    </TableCell>
                    <TableCell>
                        Company
                    </TableCell>
                    <TableCell>
                        Tipe Kontrak
                    </TableCell>
                    <TableCell>
                        Tanggal Mulai
                    </TableCell>
                </TableRow>
            </TableHead>
            {kontrakposts?.map((post) => (
                <TableBody>
                    <TableRow hover sx={{ '&:hover': {
                        backgroundColor: '#cceffb !important',
                        },backgroundColor: post.statNotify === 'No' ? 'red' : 'white'}}>
                        <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                            <p>{post.KlienNama}</p>
                        </TableCell>
                        <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                            <p>{post.CompanyName}</p>
                        </TableCell>
                        <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                            <p>{post.TipeKontrak}</p>
                        </TableCell>
                        <TableCell>
                        <p>{new Date(post.TanggalMulai).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                        </TableCell>
                    </TableRow>
                </TableBody>
            ))}
            {isEnd}
        </Table>
    </TableContainer>
</Paper>
</Grid>  </Grid>  };